




































import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import { phoneTagList } from "@/services/config";

@Component
export default class TextEditorSm extends Vue {
  @Model('change')
  value!: string;

  @Emit('change')
  change() {
     return this.getNewValue();
  }

  @Watch('value')
    getValue(value: string) {
      if (value !== this.getNewValue()) {
          (this.$refs.editor as HTMLElement).innerHTML = value;
      }
  }

  @Prop({
    type: String,
    default() {
        return '';
    },
  })
  placeholder!: string;

  // 光标位置
  public selectionRange!: Range;
  // 标签详情
  public tooltipVisible = false;
  // 当前标签属性
  public activeTag: {
      key: string;
      defaultValue: string;
      element: HTMLInputElement | null;
  } = {
      key: '',
      defaultValue: '',
      element: null
  }
  public phoneTagList = phoneTagList;

  
  mounted() {
    this.getValue(this.value);
  }

  getNewValue() {
      // console.log((this.$refs.editor as HTMLElement).innerText)
    return (this.$refs.editor as HTMLElement).innerText.replace(/\n\n/g,'\n')
      ?.replace(/ /g,String.fromCharCode(32)) // String.fromCharCode(160) -> String.fromCharCode(32)
  }

  /**
   * 选择时恢复光标位置
   */ 
  showTagList() {
      if(!this.selectionRange) {
          this.initRange(this.$refs.editor as HTMLElement);
      } else {
          this.restoreRange(this.selectionRange);
      }
  }
  
  /**
  * 新增属性
  * @param item
  */
  addTag(item: {label: string, value: string}) {
    const editor = this.$refs.editor as HTMLElement;
    editor?.focus();
    this.restoreRange(this.selectionRange);
    const tag = `{{${item.value}}}&nbsp;`;
    document.execCommand('insertHTML', false, tag);
    (this.$refs.popover as any).doClose();
  }

  handleEnter(e: Event) {
      // e.preventDefault();
      // document.execCommand('insertHTML', false, '\n');
  }

  /**
  * 监听光标变化
  */
  addSelectionchangeListener() {
    document.addEventListener('selectionchange', this.onSelectionChange);
  }

  /**
  * 解除监听光标变化
  */
  removeSelectionchangeListener() {
    document.removeEventListener('selectionchange', this.onSelectionChange);
  }

  /**
  * 恢复光标位置
  * @param range
  */
  restoreRange(range: Range) {
    const selection = document.getSelection();
    if (!selection) {
        return;
    }
    selection.removeAllRanges();
    const newRange = document.createRange();
    newRange.setStart(range.startContainer, range.startOffset);
    newRange.setEnd(range.endContainer, range.endOffset);

    selection.addRange(newRange);
  }

  /**
  * 光标位置变化事件
  */
  onSelectionChange() {
      try {
          const range = document.getSelection()?.getRangeAt(0);
          if (range) {
              this.selectionRange = range;
          }
      } catch (error) {}
  }

  /**
  * 设置光标初始位置
  * @param element
  */
  initRange (element: HTMLElement) {
    const selection = document.getSelection();
    if (!selection) {
        return;
    }
    selection.removeAllRanges();
    const newRange = document.createRange();
    newRange.selectNodeContents(element);
    newRange.setEnd(newRange.endContainer, 0);

    this.selectionRange = newRange;
    selection.addRange(newRange);
  }

  textPaste(event: any) {
    event.preventDefault();
    let text;
    const clp = (event.originalEvent || event).clipboardData;
    // 兼容针对于opera ie等浏览器
    if (clp === undefined || clp === null) {
        // @ts-ignore
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
            if (window.getSelection) {
                // 针对于ie11 10 9
                const newNode = document.createElement("span");
                newNode.innerHTML = text;
                window.getSelection()?.getRangeAt(0).insertNode(newNode);
            } else {
                // @ts-ignore 兼容ie10 9 8 7 6 5
                document.selection.createRange().pasteHTML(text);
            }
        }
    } else {
        // 兼容chorme或hotfire
        text = (clp.getData('text/plain') || "").replace(/\n/g, ' ');
        if (text !== "") {
            document.execCommand('insertText', false, text);
        }
    }
  }

}

